import { graphql } from '@/gql';
import type { ScheduledGroceryInputType } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getScheduledGroceryEstimate = async (data: ScheduledGroceryInputType) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      data,
    },
    query: graphql(`
      query GetScheduledGroceryEstimate($data: ScheduledGroceryInputType!) {
        getScheduledGroceryEstimate(data: $data) {
          total
          currency
          receiptLines {
            label
            description
            value
          }
        }
      }
    `),
  });

  return response.data.getScheduledGroceryEstimate;
};
